import {
  SET_START_TIME,
  SET_USERNAME,
  SET_PASSWORD,
  TOGGLE_HAS_SELECTED_STAY_LOGGED_IN,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  LOGGED_IN_CHECK_REQUEST,
  LOGGED_IN_CHECK_SUCCESS,
  LOGGED_IN_CHECK_FAILURE
} from 'constants/actionTypes';

export function setStartTime() {
  return {
    type: SET_START_TIME
  };
}

export function setUsername(value) {
  return {
    type: SET_USERNAME,
    value
  };
}

export function setPassword(value) {
  return {
    type: SET_PASSWORD,
    value
  };
}

export function toggleHasSelectedStayLoggedIn() {
  return {
    type: TOGGLE_HAS_SELECTED_STAY_LOGGED_IN
  };
}

export function login() {
  return {
    type: LOGIN_REQUEST
  };
}

export function loginSuccess(user) {
  return {
    type: LOGIN_SUCCESS,
    user
  };
}

export function logout(countryCode) {
  return {
    type: LOGOUT_REQUEST,
    countryCode
  };
}

/**
 * Login Failure action-creator returns login API error code
 * @param {String} errorText - Error code received from the login API call
 * @return {Object} Redux Action
 */
export function loginFailure(errorText) {
  return {
    type: LOGIN_FAILURE,
    errorText
  };
}


export function logoutSuccess() {
  return {
    type: LOGOUT_SUCCESS
  };
}

export function logoutFailure() {
  return {
    type: LOGOUT_FAILURE
  };
}

export function loggedInCheck() {
  return {
    type: LOGGED_IN_CHECK_REQUEST
  };
}

export function loggedInCheckSuccess(user) {
  return {
    type: LOGGED_IN_CHECK_SUCCESS,
    user
  };
}

export function loggedInCheckFailure() {
  return {
    type: LOGGED_IN_CHECK_FAILURE
  };
}
